export default "__VITE_ASSET__C5QT9kY1__"